<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <div class="block" style="border-bottom: 0;padding: 5px 0;">
        <el-input v-model.trim="searchVal" class="width_200" placeholder="请输入手机/姓名" @keyup.enter.native="search(1)">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search(1)"></i>
        </el-input>
        <el-button class="ml_20" type="primary" @click="exportList">导出Excel</el-button>
      </div>
      <div class="commonTable">
        <el-table :data="memberTable" tooltip-effect="light">
          <el-table-column prop="clientName" label="姓名" width="120px" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" width="140px" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="packageName" label="美容套餐" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="最近一次购买/续费时间" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.lastBuyOrRenewTime || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="最近一次划扣时间" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.lastUseTime || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="累计购买/续费" width="140px" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.total }}元</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="memberTable.length > 0" class="blockThree">
        <el-pagination background :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getClientBeautyPackageList } from '../../api/index.js';

export default {
  data() {
    return {
      searchVal: '', // 用户列表搜索值
      memberTable: [], // 用户列表
      pageNum: 1, // 当前页
      rowCount: 0, // 列表总条数
    };
  },
  activated() {
    this.search();
  },
  methods: {
    // 导出用户列表Excel
    exportList() {
      window.location.href = `${this.Lib.A()}/erp/lookVipCard/exportClientBeautyPackageList?mainId=${window.sessionStorage.mainId}&keyWord=${this.searchVal}`;
    },
    // 搜索用户列表
    search(val) {
      this.Lib.keyboardBlur();
      if (val) {
        this.pageNum = val * 1;
      } else {
        this.pageNum = 1;
      }
      const data = {
        pageNum: this.pageNum,
        mainId: window.sessionStorage.mainId,
        keyWord: this.searchVal
      };
      getClientBeautyPackageList(data).then((res) => {
        if (res.code == 0) {
          this.memberTable = res.data ? res.data.records : [];
          this.rowCount = res.data ? res.data.total : 0;
        } else {
          this.memberTable = [];
          this.rowCount = 0;
          // console.log(res)
        }
      });
    },
    handleSizeChange(val) {
      this.search(val);
    },
    handleCurrentChange(val) {
      this.search(val);
    }
  }
};
</script>
